/**
 * MD-12 FE-SHORTCUT — catalog of 7 LOW Day-1 SKUs (F-U-24)
 *
 * Per LEGAL §5 lock: ONLY 7 LOW Day-1 use cases (5 LOW expat + 2 LOW-MED
 * SME). MED/HIGH risk DEFER. Modifications require legal-upl approval +
 * DECISIONS supersede entry.
 */

import type { CatalogEntry, Lang } from './types';

export const CATALOG: CatalogEntry[] = [
  {
    shortcut_id: 'trc-renewal',
    title_vn: 'Gia hạn TRC',
    title_en: 'TRC Renewal',
    description_vn: 'Hướng dẫn gia hạn thẻ tạm trú cho người nước ngoài.',
    description_en: 'Step-by-step renewal guide for foreigner Temporary Residence Card.',
    step_count: 7,
    est_minutes: 8,
    risk_class: 'LOW',
    segment: 'expat',
  },
  {
    shortcut_id: 'wp-change',
    title_vn: 'Đổi loại Work Permit',
    title_en: 'Work Permit Change',
    description_vn: 'Thay đổi loại giấy phép lao động khi đổi vị trí/công ty.',
    description_en: 'Change work permit type when switching position/company.',
    step_count: 6,
    est_minutes: 7,
    risk_class: 'LOW',
    segment: 'expat',
  },
  {
    shortcut_id: 'visa-compare',
    title_vn: 'So sánh visa DN/LĐ/ĐT',
    title_en: 'Visa DN/LD/DT Comparison',
    description_vn: 'So sánh visa doanh nghiệp, lao động, đầu tư cho expat.',
    description_en: 'Compare DN, LD, DT visa types for expats in Vietnam.',
    step_count: 5,
    est_minutes: 5,
    risk_class: 'LOW',
    segment: 'expat',
  },
  {
    shortcut_id: 'apostille-guide',
    title_vn: 'Hướng dẫn Apostille',
    title_en: 'Apostille Document Guide',
    description_vn: 'Hợp pháp hoá lãnh sự + apostille tài liệu nước ngoài.',
    description_en: 'Foreign document legalization + apostille step-by-step.',
    step_count: 5,
    est_minutes: 6,
    risk_class: 'LOW',
    segment: 'expat',
  },
  {
    shortcut_id: 'foreigner-30-pct',
    title_vn: 'Kiểm tra sở hữu 30% nước ngoài',
    title_en: 'Foreigner-30% Ownership Check',
    description_vn: 'Tra ngành nghề có giới hạn sở hữu 30% nước ngoài.',
    description_en: 'Check if your industry has the 30% foreign ownership cap.',
    step_count: 5,
    est_minutes: 4,
    risk_class: 'LOW',
    segment: 'expat',
  },
  {
    shortcut_id: 'gpdkkd-setup',
    title_vn: 'Thiết lập GPĐKKD',
    title_en: 'GPDKKD Setup Checker',
    description_vn: 'Kiểm tra hồ sơ đăng ký kinh doanh cho doanh nghiệp mới.',
    description_en: 'Validate business registration paperwork for new SME.',
    step_count: 8,
    est_minutes: 10,
    risk_class: 'LOW_MED',
    segment: 'sme',
  },
  {
    shortcut_id: 'hdld-template-pick',
    title_vn: 'Chọn mẫu HĐLĐ',
    title_en: 'Employment Contract Template Picker',
    description_vn: 'Chọn mẫu hợp đồng lao động phù hợp loại hình tuyển dụng.',
    description_en: 'Pick the right employment contract template for your hire.',
    step_count: 6,
    est_minutes: 7,
    risk_class: 'LOW_MED',
    segment: 'sme',
  },
];

export function listCatalog(_lang: Lang): CatalogEntry[] {
  // Lang argument reserved for future locale-specific filtering; today the
  // catalog is bilingual so all entries returned regardless.
  return CATALOG;
}

export function findShortcut(shortcut_id: string): CatalogEntry | null {
  return CATALOG.find((c) => c.shortcut_id === shortcut_id) ?? null;
}
